import LegalPageLayout from './LegalPageLayout';
import { COMPANY_INFO } from '../constants/companyInfo';

export default function KvkkDisclosurePage() {
  return (
    <LegalPageLayout title="KVKK Aydınlatma Metni">
      <p>
        6698 sayılı Kişisel Verilerin Korunması Kanunu (“KVKK”) kapsamında, kişisel verilerinizin veri sorumlusu sıfatıyla{' '}
        <strong>{COMPANY_INFO.name}</strong> tarafından aşağıda açıklanan kapsamda işlenmesine ilişkin bilgilendirme yapılmaktadır.
      </p>

      <h2>1. Veri Sorumlusu</h2>
      <p>
        Veri Sorumlusu: {COMPANY_INFO.name}
        <br />
        E-posta: <a href={`mailto:${COMPANY_INFO.email}`}>{COMPANY_INFO.email}</a>
        <br />
        Telefon: {COMPANY_INFO.phoneDisplay}
        <br />
        Adres: {COMPANY_INFO.address}
      </p>

      <h2>2. İşlenen Kişisel Veriler</h2>
      <ul>
        <li>Kimlik ve iletişim verileri (ad soyad, e-posta, telefon)</li>
        <li>İletişim/başvuru formu içerikleri</li>
        <li>İşlem güvenliği verileri (IP, kullanıcı ajanı, log kayıtları)</li>
        <li>Kullanım ve talep bilgileri</li>
      </ul>

      <h2>3. Kişisel Verilerin İşlenme Amaçları</h2>
      <ul>
        <li>Hizmet süreçlerinin yürütülmesi ve geliştirilmesi</li>
        <li>Başvuru ve müşteri iletişim süreçlerinin yönetimi</li>
        <li>Bilgi güvenliği ve operasyonel denetim</li>
        <li>Yasal yükümlülüklerin yerine getirilmesi</li>
      </ul>

      <h2>4. Kişisel Verilerin Aktarılması</h2>
      <p>
        Kişisel verileriniz; mevzuata uygunluk, sözleşmesel süreçlerin yürütülmesi ve teknik altyapı hizmetlerinin sağlanması amacıyla,
        hukuki sınırlar çerçevesinde yetkili kurum/kuruluşlara ve hizmet alınan iş ortaklarına aktarılabilir.
      </p>

      <h2>5. Toplama Yöntemi ve Hukuki Sebep</h2>
      <p>
        Verileriniz; web formları, dijital iletişim kanalları ve sistem logları üzerinden otomatik veya kısmen otomatik yollarla toplanır.
        KVKK m.5 kapsamında açık rıza, sözleşmenin kurulması/ifası, hukuki yükümlülüklerin yerine getirilmesi ve meşru menfaat hukuki
        sebeplerine dayanılarak işlenebilir.
      </p>

      <h2>6. KVKK m.11 Kapsamındaki Haklarınız</h2>
      <ul>
        <li>Kişisel veri işlenip işlenmediğini öğrenme</li>
        <li>İşlenen verilere ilişkin bilgi talep etme</li>
        <li>İşleme amacını ve amaca uygun kullanımı öğrenme</li>
        <li>Eksik veya yanlış işlenen verilerin düzeltilmesini isteme</li>
        <li>KVKK’ya uygun olarak silinmesini veya yok edilmesini isteme</li>
        <li>İşleme faaliyetlerine itiraz etme</li>
      </ul>

      <h2>7. Başvuru Usulü</h2>
      <p>
        KVKK kapsamındaki taleplerinizi, kimliğinizi tevsik eden bilgilerle birlikte <a href={`mailto:${COMPANY_INFO.email}`}>
          {COMPANY_INFO.email}
        </a>{' '}
        adresine iletebilirsiniz. Başvurular mevzuatta öngörülen süreler içinde sonuçlandırılır.
      </p>
    </LegalPageLayout>
  );
}
